import room_size from "../images/primary/size_room.png";
import size_sqft from "../images/primary/size_sqft.png";
import location_icon from "../images/primary/location.png";
import Propertydata from "../Utils/property_data.json";
import { useState } from "react";

function Property_filtering() {
  const [search, setSearch] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [price, setPrice] = useState("");
  const [landArea, setLandArea] = useState("");
  const [saleType, setSaleType] = useState("");

  const parsePrice = (priceStr) => {
    console.log(priceStr);
    if (!priceStr) return 0;
    const str = priceStr.toLowerCase().replace(/\s/g, "");

    if (str.includes("cr")) {
      return parseFloat(str) * 10000000;
    }
    if (str.includes("l")) {
      return parseFloat(str) * 100000;
    }
    return parseFloat(str) || 0;
  };
  const filteredData = Propertydata.filter((item) => {
    const priceValue = parsePrice(item.price);
    if (search && !(item.detail || " ").toLowerCase().includes(search.toLowerCase())) {
      return false;
    }
    if (
      propertyType &&
      item.property_type.trim().toLowerCase() !== propertyType.toLowerCase()
    ) {
      return false;
    }

    if (price) {
      if (price === "below50" && priceValue >= 5000000) return false;
      if (
        price === "50to100" &&
        (priceValue < 5000000 || priceValue > 10000000)
      )
        return false;
      if (
        price === "100to500" &&
        (priceValue < 10000000 || priceValue > 50000000)
      )
        return false;
      if (
        price === "500to1000" &&
        (priceValue < 50000000 || priceValue > 100000000)
      )
        return false;
      if (price === "above10cr" && priceValue <= 100000000) return false;
    }

    if (landArea) {
      const areaNum = parseFloat(item.area);
      if (landArea === "600to800" && (areaNum < 600 || areaNum > 800))
        return false;
      if (landArea === "800to1000" && (areaNum < 800 || areaNum > 1000))
        return false;
      if (landArea === "1000to1200" && (areaNum < 1000 || areaNum > 1200))
        return false;
      if (landArea === "1200to3000" && (areaNum < 1200 || areaNum > 3000))
        return false;
    }
    if (saleType) {
    const saleValue = (item["sale_type "] || item.sale_type || "").trim().toLowerCase();
    if (saleValue !== saleType.toLowerCase()) return false;
  }
    return true;
  });

  console.log(saleType);
  return (
    <div className="bg-white max-w-7xl mx-auto">
      <div className="m-6 space-x-2">
        <input
          type="text"
          placeholder="Search by location"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-[200px] border font-light border-gray-300 rounded-lg p-2 text-sm"
        />
        <select
          className="w-[200px] border font-light border-gray-300 rounded-lg p-2 text-sm"
          value={propertyType}
          onChange={(e) => setPropertyType(e.target.value)}
        >
          <option value="">Select Property Type</option>
          <option value="apartment">Apartment</option>
          <option value="villa">Villa</option>
          <option value="plots">Plots</option>
          <option value="office space">Office Space</option>
        </select>
        <select
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          className="w-[200px] border font-light border-gray-300 rounded-lg p-2 text-sm"
        >
          <option value="">Select Price</option>
          <option value="below50">Below 50L</option>
          <option value="50to100">50L - 1Cr</option>
          <option value="100to500">1Cr - 5Cr</option>
          <option value="500to1000">5Cr & 10Cr</option>
          <option value="above10cr"> 10Cr & above</option>
        </select>
        <select
          className="w-[200px] border font-light border-gray-300 rounded-lg p-2 text-sm"
          value={landArea}
          onChange={(e) => setLandArea(e.target.value)}
        >
          <option value="">Select Land Area</option>
          <option value="600to800">600 - 800 Sq.ft</option>
          <option value="800to1000">800 - 1000 Sq.ft</option>
          <option value="1000to1200">1000 - 1200 Sq.ft</option>
          <option value="1200to3000">1200- 3000 Sq.ft</option>
        </select>
        <select
          className="w-[200px] border font-light border-gray-300 rounded-lg p-2 text-sm"
          value={saleType}
          onChange={(e) => setSaleType(e.target.value)}
        >
          <option value="">Select Type</option>
          <option value="firstsale">First Sale</option>
          <option value="resale">Re-sale</option>
        </select>
      </div>
      <div className="max-w-[1337px] mx-auto py-">
        <div className="grid grid-cols-2 lg:grid-cols-3 items-center gap-16 mt-20">
          {filteredData.length > 0 ? (
            filteredData.map((item, idx) => (
              <div key={idx} className="bg-white relative w-[425px] h-fit py-3 shadow-lg rounded-[8px]">
                <div className="relative">
                  <img src={item.image} alt="property_images" className="w-full h-[244px]" />
                  <p className="font-[alibabasans] text-[16px] px-[4px] py-[8px] w-fit bg-yellow text-hblack rounded-[8px] absolute top-3 right-3">
                    {item.exclusive}
                  </p>
                </div>

                <div className="px-4 mt-3">
                  <h2 className="font-noto text-[26px] text-hblack font-semibold leading-[40px]">
                    {item.name}
                  </h2>

                  <div className="flex flex-row items-center gap-x-3 mt-3">
                    <img
                      src={location_icon}
                      alt="location-icon"
                      className="w-[18px] h-[25px]"
                    />
                    <p className="font-[alibabasans] text-font-grey text-[18px]">
                      {item.detail}
                    </p>
                  </div>

                  {/* Type & Area */}
                  <div className="flex flex-row items-center justify-between mt-5">
                    <div className="flex flex-row items-center gap-x-2">
                      <img
                        src={room_size}
                        alt="room-size"
                        className="w-[25px] h-[18px]"
                      />
                      <p className="text-[20px] font-semibold text-font-grey uppercase">
                        {item.type}
                      </p>
                    </div>

                    <div className="flex flex-row items-center gap-x-2">
                      <img
                        src={size_sqft}
                        alt="sqft-size"
                        className="w-[14px] h-[17px]"
                      />
                      <p className="text-[20px] font-semibold text-font-grey">
                        {item.area}
                      </p>
                    </div>
                  </div>

                  <hr className="border-[#E5E5E5] border-t-[2px] w-full my-5" />

                  <div className="flex flex-row items-end justify-between">
                    <h4 className="text-[36px] text-brown font-bold">
                      ₹ {item.price}
                    </h4>
                    <p className="text-[14px] text-font-grey">{item.status}</p>
                  </div>

                  {/* Buttons */}
                  <div className="flex flex-row items-center justify-between mt-12">
                    <button className="w-[188px] py-[15px] bg-[#F5D000] hover:bg-white hover:border-[2.5px] hover:border-yellow">
                      Enquire
                    </button>
                    <button className="w-[188px] py-[13px] border-[2.5px] border-yellow hover:bg-yellow">
                      Chat with us
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm">No matched</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Property_filtering;
